<template>
  <div class="member-counter">
    <div
      class="member-circle"
      v-for="(member, index) in membersToShow"
      :key="index"
      :id="member.id"
    >
      <span>{{member.initalLetter}}</span>
      <b-tooltip
        v-if="tooltips"
        :target="member.id"
        triggers="hover"
        variant="secondary"
        placement="bottomleft"
      >{{member.name}}</b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    membersToShow: {
      type: Array,
      required: true,
      default: ()=> {return [];}
    },
    tooltips: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.member-counter {
  vertical-align: top;
  text-align: right;
}

.member-counter .member-circle {
  display: inline-block;
  z-index: 3;
  background: theme.$secondary-color;
  color: theme.$text-color;
  font-size: 12px;
  height: 25px;
  width: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid white;
  box-sizing: content-box;
  margin-left: -8px;
}

//For List page
.members-circles-style.member-counter {
  text-align: left;
  display: inline-block;
  margin-left: 6px;
}

.members-circles-style .member-circle {
  transform: scale(1.2);
}
.members-circles-style .member-circle:not(:first-child) {
  margin-left: 6px;
}

</style>